/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
//import { Link } from "react-router-dom";
import { useState } from "react";
import cuarto from "../../../../assets/img/dormitorio-por-dentro.png";
import cuarto2 from "../../../../assets/img/dormitorio-por-dentro2.png";
import casa from "../../../../assets/img/casa-final-en-perspectiva.png";
import Espacio from "./Espacio";
import Tipo from "./Tipo";
import Direccion from "./Direccion";
import DatosBasicos from "./Datos";
import Servicios from "./Servicios";
import Horarios from "./Horarios";
import Imagenes from "./Imagenes";
import Descripciones from "./Descripciones";
import Precio from "./Precio";
//import Descuentos from "./Descuentos";
import Carousel from "../../../../components/UI/Carousel";
import { FORMs } from "../../../../conts/Property";
import { imagesProperty } from "../../../../utils/carousel";
import { useNavigate } from "react-router-dom";
import { myHeaders } from "../../../../config/axios";
import Tarifas from "./Tarifas";
import { URL_API } from "../../../../config/default";
import { CustomToast } from "../../../../utils/custom-toast";

const PasosAlquiler = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState<any>(FORMs.PROPERTY);
  const [label, setLabel] = useState(0);

  const favorite = () => { };

  const pasos = () => {
    switch (label) {
      case 0:
        return (
          <div className="h-[100%] flex justify-center items-center">
            <div className="grid grid-cols-1 lg:grid-cols-2 ">
              <div className="px-2">
                <span className="text-primary font-bold text-xl">Paso 1</span>
                <span className="block font-bold my-3">
                  Contanos acerca de tu alojamiento
                </span>

                <div className="mb-5">
                  <span className="block">
                    En este paso, te vamos a preguntar que tipo de propiedad
                    tenes y si los huespedes van a reservar el alojamiento
                    entero o solo una habitacion. hacenos saber la ubicación y
                    cuántos huéspedes pueden quedarse en el alojamiento.
                  </span>
                </div>
              </div>
              <div className="flex justify-center w-full px-2">
                <img
                  src={cuarto}
                  alt=""
                  className="w-[300px] h-auto object-cover"
                />
              </div>
            </div>
          </div>
        );
        break;
      case 1:
        return <Espacio setForm={setForm} form={form} />;
        break;
      case 2:
        return <Tipo setForm={setForm} form={form} />;
        break;
      case 3:
        return <Direccion setForm={setForm} form={form} />;
        break;
      case 4:
        return <DatosBasicos setForm={setForm} form={form} />;
        break;
      case 5:
        return (
          <div className="h-[100%] flex justify-center items-center">
            <div className="grid lg:grid-cols-2 gap-10 py-5 px-5">
              <div>
                <span className="text-primary font-bold text-xl">Paso 2</span>
                <span className="block font-bold my-3">
                  Hacé que tu espacio se destaque
                </span>

                <div className="mb-5">
                  <span className="block">
                    En este paso, agregá algunos de los servicios que ofrece tu
                    espacio, y cinco fotos o más. Luego, vas a tener que crear
                    un titulo, o una descripción.
                  </span>
                </div>
              </div>
              <div className="flex justify-center w-full px-2">
                <img
                  src={cuarto2}
                  alt=""
                  className="w-[300px] h-auto object-cover"
                />
              </div>
            </div>
          </div>
        );
        break;
      case 6:
        return <Servicios setForm={setForm} form={form} />;
        break;
      case 7:
        return <Horarios setForm={setForm} form={form} />;
        break;
      case 8:
        return <Imagenes setForm={setForm} form={form} />;
        break;
      case 9:
        return <Descripciones setForm={setForm} form={form} />;
        break;
      case 10:
        return (
          <div className="h-[100%] flex justify-center items-center">
            <div className="grid lg:grid-cols-2 gap-10 py-5 px-5">
              <div>
                <span className="text-primary font-bold text-xl">Paso 3</span>
                <span className="block font-bold my-3">
                  Terminá todo y publicá el anuncio
                </span>

                <div className="mb-5">
                  <span className="block">
                    Vas a establecer tu precio por noche. Después, solo tenés
                    que responder algunas preguntas y publicar tu anuncio cuando
                    tengas todo listo.
                  </span>
                </div>
              </div>
              <div className="flex justify-center w-full px-2">
                <img
                  src={casa}
                  alt=""
                  className="w-[300px] h-auto object-cover"
                />
              </div>
            </div>
          </div>
        );
        break;
      case 11:
        return <Precio setForm={setForm} form={form} />;
        break;
      case 12:
        return <Tarifas setForm={setForm} form={form} />;
        break;
      /*case 13:
        return <Descuentos setForm={setForm} form={form} />;
        break;*/
      case 13:
        return (
          <div className="h-[100%] flex justify-center items-center">
            <div className="grid lg:grid-cols-2 gap-10 py-5 px-5">
              <div>
                <span className="text-primary font-bold text-xl">Paso 3</span>
                <span className="block font-bold my-3">
                  Es hora de publicar tu espacio
                </span>

                <div className="mb-5">
                  <span className="block">
                    Esto es lo que les vamos a mostrar a los huéspedes. Antes de
                    publicar el anuncio, asegúrate de revisar todos los
                    detalles.
                  </span>
                </div>

                <div className="w-[100%] md:w-[100%] p-2">
                  <Carousel
                    user={undefined}
                    setFavorite={favorite}
                    favorites={{ data: [] }}
                    slides={
                      form.IMAGES.length > 0
                        ? imagesProperty(form)
                        : [
                          {
                            id: null,
                            url: "https://i.pinimg.com/originals/51/82/ac/5182ac536727d576c78a9320ac62de30.jpg",
                            title: form.title,
                            distance: "",
                            available: "",
                            fee: "$" + form.price,
                            link: "#",
                            ratings: null,
                          },
                        ]
                    }
                  />
                </div>
              </div>
              <div></div>
            </div>
          </div>
        );
        break;
    }
  };

  /*
  function convertFileToBase64(file: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = function (event: any) {
        const base64String = event.target.result; // Extract base64 part from the result
        resolve(base64String);
      };

      reader.onerror = function (error) {
        reject(error);
      };

      reader.readAsDataURL(file); // Read the file as a data URL
    });
  }
  */

  const upload = async (property: any) => {
    const formdata = new FormData();
    formdata.append("property_id", property.id);

    for (let index = 0; index < form.IMAGES.length; index++) {
      //const file = await convertFileToBase64(form.IMAGES[index].file);
      formdata.append("file[" + index + "]", form.IMAGES[index].file);
    }

    const requestOptions = {
      method: "POST",
      body: formdata,
      headers: {
        Authorization: myHeaders, // Un ejemplo de header de autenticación
      },
    };

    fetch(`${URL_API}/properties/upload`, requestOptions)
      .then(async (res) => {
        if (res.ok) {
          CustomToast({
            status: 200,
            msg: "",
            title: "Imagenes cargadas",
          });
          setLoading(false);
          return navigate("/");
        }
      })
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  };

  const onClick = async (e: any) => {
    switch (e.target.name) {
      case "save":
        {
          setLoading(true);
          let formdata = new FormData();
          formdata.append("title", form.title);
          formdata.append("description", form.description);
          formdata.append("type", form.type);
          formdata.append("space", form.space);
          formdata.append("address", form.address);
          formdata.append("country", form.country);
          formdata.append("province", form.province);
          formdata.append("city", form.city);
          formdata.append("postal_code", form.postal_code);
          formdata.append("show_location", String(form.show_location));

          if (form.show_location) {
            formdata.append("lat", String(form.lat));
            formdata.append("lon", String(form.lon));
          }

          formdata.append("floor", form.floor);
          formdata.append("highlight", "1");
          formdata.append("address_line_three", form.address_line_three);
          formdata.append("address_line_four", form.address_line_four);
          formdata.append("bedrooms", String(form.bedrooms));
          formdata.append("bathrooms", String(form.bathrooms));
          formdata.append("beds", String(form.beds));
          formdata.append("travellers", String(form.travellers));
          formdata.append("min_nights", form.min_nights);
          formdata.append("max_nights", form.max_nights);
          formdata.append("price", String(form.price));
          formdata.append("price_intelligent", "0");
          formdata.append("state", "1");
          formdata.append("SERVICES", JSON.stringify(form.SERVICES));
          formdata.append("CHECKIN", JSON.stringify(form.CHECKIN));
          formdata.append("CHECKOUT", JSON.stringify(form.CHECKOUT));
          if (form.PRICES.length > 0)
            formdata.append("PRICES", JSON.stringify(form.PRICES));
          formdata.append(
            "DESCRIPTIONs",
            JSON.stringify(form.DESCRIPTION_PROPERTY)
          );
          formdata.append("FEES", JSON.stringify(form.FEES));

          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders, // Un ejemplo de header de autenticación
            },
          };

          fetch(`${URL_API}/properties`, requestOptions)
            .then(async (response) => {
              const property = await response.json();

              if (form.IMAGES.length !== 0) {
                upload(property.data);
              }

              CustomToast({
                status: 200,
                msg: "",
                title: "Alojamiento creado con exito",
              });
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;
    }
  };

  const next = () => {
    switch (label) {
      case 0:
        {
          return (
            <button
              className={`cursor-pointer flex rounded-full btn btn-filled-2`}
              style={{ borderRadius: "20px" }}
              onClick={() => setLabel(label + 1)}
            >
              Siguiente
            </button>
          );
        }
        break;
      case 1:
        {
          if (form.type.trim() !== "") {
            return (
              <button
                className={`cursor-pointer flex rounded-full btn btn-filled-2`}
                style={{ borderRadius: "20px" }}
                onClick={() => setLabel(label + 1)}
              >
                Siguiente
              </button>
            );
          }
        }
        break;
      case 2:
        {
          if (form.space.trim() !== "") {
            return (
              <button
                className={`cursor-pointer flex rounded-full btn btn-filled-2`}
                style={{ borderRadius: "20px" }}
                onClick={() => setLabel(label + 1)}
              >
                Siguiente
              </button>
            );
          }
        }
        break;
      case 3:
        {
          if (
            form.address.trim() !== "" &&
            form.province.trim() !== "" &&
            //form.postal_code.trim() !== "" &&
            form.city.trim() !== ""
            //form.floor.trim() !== ""
            //form.address_line_three.trim() !== "" &&
            //form.address_line_four.trim() !== ""
          ) {
            return (
              <button
                className={`cursor-pointer flex rounded-full btn btn-filled-2`}
                style={{ borderRadius: "20px" }}
                onClick={() => setLabel(label + 1)}
              >
                Siguiente
              </button>
            );
          }
        }
        break;
      case 6:
        {
          if (form.SERVICES.length !== 0) {
            return (
              <button
                className={`cursor-pointer flex rounded-full btn btn-filled-2`}
                style={{ borderRadius: "20px" }}
                onClick={() => setLabel(label + 1)}
              >
                Siguiente
              </button>
            );
          }
        }
        break;
      case 7:
        {
          if (form.CHECKIN.time && form.CHECKOUT.time) {
            return (
              <button
                className={`cursor-pointer flex rounded-full btn btn-filled-2`}
                style={{ borderRadius: "20px" }}
                onClick={() => setLabel(label + 1)}
              >
                Siguiente
              </button>
            );
          }
        }
        break;
      case 8:
        {
          if (form.IMAGES.length !== 0) {
            return (
              <button
                className={`cursor-pointer flex rounded-full btn btn-filled-2`}
                style={{ borderRadius: "20px" }}
                onClick={() => setLabel(label + 1)}
              >
                Siguiente
              </button>
            );
          }
        }
        break;
      case 9:
        {
          if (
            form.DESCRIPTION_PROPERTY.length !== 0 &&
            form.title.trim() !== "" &&
            form.description.trim() !== ""
          ) {
            return (
              <button
                className={`cursor-pointer flex rounded-full btn btn-filled-2`}
                style={{ borderRadius: "20px" }}
                onClick={() => setLabel(label + 1)}
              >
                Siguiente
              </button>
            );
          }
        }
        break;
      default:
        return (
          <button
            className={`cursor-pointer flex rounded-full btn btn-filled-2`}
            style={{ borderRadius: "20px" }}
            onClick={() => setLabel(label + 1)}
          >
            Siguiente
          </button>
        );
    }
  };

  return (
    <div className="mx-auto md:w-[80%] w-full h-[100vh] bg-white rounded-lg shadow-sm border px-1">
      <label className="cursor-pointer flex justify-center hover:bg-gray-20 px-2 py-2 rounded-full text-dark font-bold block w-[100px] my-2">
        <i className="bi bi-chevron-left text-md me-2"></i>Salir
        <button className="hidden" onClick={() => navigate("/")}></button>
      </label>
      <div className="h-[70%] overflow-auto">{pasos()}</div>
      <div className="h-[20%] w-full bottom-0 py-4 bg-white">
        <div className="grid grid-cols-3 gap-3">
          <div className="w-full bg-gray-200 rounded-full h-1 dark:bg-gray-700 my-5 ">
            <div
              className="bg-primary h-1 rounded-full"
              style={{ width: label >= 5 ? "100%" : label * 25 + "%" }}
            ></div>
          </div>

          <div className="w-full bg-gray-200 rounded-full h-1 dark:bg-gray-700 my-5">
            <div
              className="bg-primary h-1 rounded-full"
              style={{
                width:
                  label >= 10
                    ? "100%"
                    : (label - 5 < 0 ? 0 : label - 5) * 25 + "%",
              }}
            ></div>
          </div>

          <div className="w-full bg-gray-200 rounded-full h-1 dark:bg-gray-700 my-5">
            <div
              className="bg-primary h-1 rounded-full"
              style={{
                width:
                  label >= 14
                    ? "100%"
                    : (label - 9 < 0 ? 0 : label - 9) * 25 + "%",
              }}
            ></div>
          </div>
        </div>
        <div className="flex justify-between">
          <label
            className="cursor-pointer flex rounded-full btn btn-filled-2"
            style={{ borderRadius: "20px" }}
          >
            Atras
            <button
              className="hidden"
              onClick={() => setLabel(label - 1)}
            ></button>
          </label>

          {label == 13 ? (
            <button
              name="save"
              onClick={(event) => onClick(event)}
              className={`cursor-pointer flex rounded-full btn btn-filled-2 ${loading ? "opacity-[0.5] cursor-not-allowed" : ""
                }`}
              style={{ borderRadius: "20px" }}
            >
              {loading ? (
                <div className="w-6 h-6 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
              ) : (
                "Publicar anuncio"
              )}
            </button>
          ) : (
            next()
          )}
        </div>
      </div>
    </div>
  );
};

export default PasosAlquiler;
